import { IMainStore } from '../typings/stores';
import LocaleHelper from '../utils/localeHelper';
import { safeExecute, safeExecuteAsync } from '../utils/safeExecute';
import GlobalAlertStore from './globalAlertStore';

export default function createStore(basePath: string): IMainStore {
	const globalAlertStore = new GlobalAlertStore();
	const localeHelper = new LocaleHelper();

	return {
		basePath,
		globalAlertStore,
		localeHelper,
		safeExecuteAsync: (action, defaultValue) => safeExecuteAsync(action, defaultValue, globalAlertStore.error),
		safeExecute: (action, defaultValue) => safeExecute(action, defaultValue, globalAlertStore.error)
	};
}
